var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isMobile)?_c('mixer-uploads-list'):_c('mixer-uploads-list-mobile')}
var staticRenderFns = []

export { render, staticRenderFns }